import React from 'react'

function Ink() {
  return (
    <section className='end'>
      <h1>Ink</h1>
      <p class="center">A remnant of something old and hungry, it tries to consume anything with enough mind, with enough vision to finally find its missing piece. Shame that the five aspects are all imagination-related aspects in one way or another.</p>
      <h1>Shards</h1>
      <p class="center">Pieces of something ancient, older than the Ink, it is a mystery how such a thing is now found in pieces. Her shards infect aspects, eating at their very being, however, those shards can only hold so much soul, and shatter themselves if they attempt to hold too many souls, or one too powerful.</p>
      <img class="portrait" alt="glowing white shard"
        src="shard.png"/>
    </section>
  )
}

export default Ink
